import React from "react";
import {Accordion, AccordionDetails, AccordionSummary, Box, Typography,} from "@mui/material";

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import FlatDpe from "./FaltDpe";
import FlatBar from "./FaltBar";
import {removeCommas} from "../svc/Utils";
import FlatBar3 from "./FaltBar3";
import {getDpeColor} from "../pages/dpeByIris/MapPage";
import DpeV2Details from "./v2/DpeV2Details";

export const resDpeV2 = {
    classe: "D",
    dpes: [
        {dpe: "G", ges: "A", inertie: "lourde", isolEnv: "moyenne", isolMenu: "bonne", isolMur: "très bonne"},
        {dpe: "F", ges: "A", inertie: "lourde", isolEnv: "moyenne", isolMenu: "bonne", isolMur: "très bonne"},
        {dpe: "E", ges: "G", inertie: "moyenne", isolEnv: "moyenne", isolMenu: "moyenne", isolMur: "très bonne"},
        {dpe: "D", ges: "A", inertie: "lourde", isolEnv: "moyenne", isolMenu: "bonne", isolMur: "très bonne"},
        {dpe: "C", ges: "C", inertie: "lourde", isolEnv: "moyenne", isolMenu: "bonne", isolMur: "très bonne"},
        {dpe: "B", ges: "A", inertie: "lourde", isolEnv: "moyenne", isolMenu: "moyenne", isolMur: "très bonne"},
        {dpe: "A", ges: "A", inertie: "moyenne", isolEnv: "moyenne", isolMenu: "bonne", isolMur: "très bonne"},
        {dpe: "D", ges: "A", inertie: "lourde", isolEnv: "moyenne", isolMenu: "bonne", isolMur: "très bonne"},
        {dpe: "C", ges: "A", inertie: "lourde", isolEnv: "moyenne", isolMenu: "moyenne", isolMur: "très bonne"},
        {dpe: "B", ges: "A", inertie: "moyenne", isolEnv: "moyenne", isolMenu: "bonne", isolMur: "très bonne"},
        {dpe: "A", ges: "A", inertie: "lourde", isolEnv: "moyenne", isolMenu: "bonne", isolMur: "très bonne"},

    ]
}

export function mergeValuesAndLabels() {

    return "1 : truc <br/> 2 : machin<br/> 3 : bidule";
}

export function mergeValuesAndLabelsV1(dpes, key,key2) {
    let res = {}
    dpes.forEach(dpe => {
        let k=key;
        if(!dpe[k]){
            k=key2;
        }
        if (!res[dpe[k]]) {
            res[dpe[k]] = 0;
        }
        res[dpe[k]]++;
    })


    return Object.keys(res).map(k => ` ${res[k]} : ${k}`).join("<br/>");
}

export default function AttributDpeV2({selectedItem}) {

    const [enableModule, setEnableModule] = React.useState(true);


    return (<Accordion
        sx={{
            margin: 2,
            '&:before': {
                display: 'none',
            },
            boxShadow: "none",
            borderColor: "rgba(0, 0, 0, 0.125)",
            borderStyle: "solid",
            borderWidth: 1,
            borderRadius: "8px"
        }}
        disabled={false}
        expanded={!enableModule}

    >
        <AccordionSummary
            expandIcon={<ExpandMoreIcon/>}
            onClick={() => {
                setEnableModule(!enableModule)
            }}>
            <Typography>Données DPE opposables logements réalisés après juillet 2021 (opposables)</Typography>
        </AccordionSummary>
        <AccordionDetails sx={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            gap: 2
        }}>
            <DpeV2Details selectedItem={selectedItem}/>
        </AccordionDetails>
    </Accordion>)
}
